/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    readonly id?: number;
    /**
     * 
     * @type {object}
     * @memberof Action
     */
    table?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof Action
     */
    readonly dateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Action
     */
    readonly dateTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Action
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Action
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    previewImage: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    detailImage: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    conditionTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    conditionText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    terms?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    descriptionNext?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    linksBlock?: string | null;
}

export function ActionFromJSON(json: any): Action {
    return ActionFromJSONTyped(json, false);
}

export function ActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Action {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'table': !exists(json, 'table') ? undefined : json['table'],
        'dateFrom': !exists(json, 'dateFrom') ? undefined : (json['dateFrom'] === null ? null : new Date(json['dateFrom'])),
        'dateTo': !exists(json, 'dateTo') ? undefined : (json['dateTo'] === null ? null : new Date(json['dateTo'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'sort': json['sort'],
        'url': json['url'],
        'title': json['title'],
        'previewImage': json['previewImage'],
        'detailImage': json['detailImage'],
        'conditionTitle': !exists(json, 'conditionTitle') ? undefined : json['conditionTitle'],
        'conditionText': !exists(json, 'conditionText') ? undefined : json['conditionText'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'descriptionNext': !exists(json, 'descriptionNext') ? undefined : json['descriptionNext'],
        'linksBlock': !exists(json, 'linksBlock') ? undefined : json['linksBlock'],
    };
}

export function ActionToJSON(value?: Action | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'table': value.table,
        'sort': value.sort,
        'url': value.url,
        'title': value.title,
        'previewImage': value.previewImage,
        'detailImage': value.detailImage,
        'conditionTitle': value.conditionTitle,
        'conditionText': value.conditionText,
        'description': value.description,
        'terms': value.terms,
        'descriptionNext': value.descriptionNext,
        'linksBlock': value.linksBlock,
    };
}


